import * as React from "react";
import Box from "@mui/material/Box";
// import axios from "axios";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import Popup from "reactjs-popup";

import { toast } from "react-toastify";
import { useState } from "react";
import { useEffect } from "react";

import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";

import Button from "@mui/material/Button";

import FileDownloadDoneIcon from "@mui/icons-material/FileDownloadDone";
import axiosInstance from "../../config/axios";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  rounded: 2,
};

const bull = (
  <Box
    component="span"
    sx={{ display: "inline-block", mx: "2px", transform: "scale(0.8)" }}
  >
    •
  </Box>
);

const WalletManagement = () => {
  const [data, setData] = useState([]);
  const [checked, setChecked] = React.useState(true);
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [vendorName, setVendorName] = useState("");
  const [vendorEmail, setVendorEmail] = useState("");
  const [vendorMobile, setVendorMobile] = useState("");
  const [vendorStore, setVendorStore] = useState("");

  const [passApproval, setPassApproval] = useState({});
  const [changeStatus, setChageStatus] = useState(null);

  const [rowData, setRowData] = useState({});

  const approvalData = () => {
    axiosInstance
      .post(
        `api/multivendor-pending-for-approval-vendor-list/`,
        {},
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        },
      )
      .then((response) => {
        setData(response?.data?.pending_for_approval);
        console.log("data==>", response?.data?.pending_for_approval);
      })
      .catch((error) => {
        console.log("", error.response);
        console.log(error);
        toast.error(error.message);
      });
  };

  const handleChange = (event) => {
    console.log(event);
    axiosInstance
      .post(
        `api/admin/vendor-registration-form-list/`,
        { mobile_no: event },
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        },
      )
      .then((response) => {
        toast.success(response?.data?.message);
        approvalData();
      })
      .catch((error) => {
        console.log("", error.response);
        console.log(error);
        toast.error(error.message);
      });
  };

  useEffect(() => {
    approvalData();
  }, []);

  const sendPaymentData = () => {
    const fd = new FormData();
    fd.append("vendor_name", vendorName || rowData?.first_name);
    fd.append("vendor_email", vendorEmail || rowData?.email);
    fd.append("vendor_mobile", vendorMobile || rowData?.mobile_no);
    fd.append("vendor_store", vendorStore || rowData?.store_name);
    axiosInstance
      .post(`api/multivendor-create-payment-link/`, fd, {
        headers: {
          Token: localStorage.getItem("Token"),
        },
      })
      .then((response) => {
        console.log(response?.data?.data);
        setPassApproval(response?.data?.data);
        toast.success("Payment Request Send Successfully...");
        setVendorEmail("");
        setVendorMobile("");
        setVendorName("");
        setVendorStore("");
        handleClose();
        approvalData();
      })
      .catch((error) => {
        console.log("", error.response);
        console.log(error);
        toast.error("please feel valid cradiantial...!");
      });
  };

  const openPaymentLink = (row) => {
    handleOpen();
    setRowData(row);
  };

  const handleStatusChange = (event, mobileNo) => {
    console.log("your status===>", event.target.value, mobileNo);
    axiosInstance
      .post(
        `api/admin/vendor-registration-form-list/`,
        { mobile_no: mobileNo, payment_status: event.target.value },
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        },
      )
      .then((response) => {
        toast.success(response?.data?.message);
        approvalData();
      })
      .catch((error) => {
        console.log("", error.response);
        console.log(error);
        toast.error(error.message);
      });
  };

  // console.log("your status===>",changeStatus)

  return (
    <>
      <div className="!bg-white">
        <div className="flex justify-between !bg-slate-100">
          <div className="p-2">
            <p className="text-xl font-bold !text-black">
              Pending For Approval List
            </p>
            <p className="!text-black">View/Search Pending for approval list</p>
          </div>
          <div className="p-2 pt-5  ">
            <div className="flex items-center p-2 h-14 !bg-slate-100 border-zinc-600">
              {/* <input
                type="text"
                className="!border-3 !border-black px-2 !w-64 rounded-md py-1"
                placeholder="search"
                style={{ border: "1px solid black" }}
              /> */}
            </div>
          </div>
        </div>
        <div className="">
          <TableContainer component={Paper} sx={{ maxHeight: 440 }}>
            <Table stickyHeader aria-label="sticky table" size="small">
              <TableHead>
                <TableRow>
                  <TableCell
                    style={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center  !text-gray-800 !font-bold"
                  >
                    <div className="w-16"> Id</div>
                  </TableCell>
                  <TableCell
                    style={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center  !text-gray-800 !font-bold"
                  >
                    <div className="w-36">STORE NAME </div>
                  </TableCell>
                  <TableCell
                    style={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center  !text-gray-800 !font-bold"
                  >
                    <div className="w-24">MOBILE NO.</div>
                  </TableCell>
                  <TableCell
                    style={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center  !text-gray-800 !font-bold"
                  >
                    <div className="w-36">EMAIL</div>
                  </TableCell>
                  <TableCell
                    style={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center  !text-gray-800 !font-bold"
                  >
                    <div className="w-40">NAME</div>
                  </TableCell>
                  <TableCell
                    style={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center  !text-gray-800 !font-bold"
                  >
                    STATUS
                  </TableCell>

                  <TableCell
                    style={{
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center  !text-gray-800 !font-bold"
                  >
                    <div className="w-40">SEND PAYMENT LINK</div>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data &&
                  data.map((row) => (
                    <TableRow
                      key={row?.id}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #D0D0D0",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {row?.id ? row?.id : "--"}
                      </TableCell>
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #D0D0D0",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {row?.store_name ? row?.store_name : "--"}
                      </TableCell>
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #D0D0D0",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {row?.mobile_no ? row?.mobile_no : "--"}
                      </TableCell>
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #D0D0D0",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {row?.email ? row?.email : "--"}
                      </TableCell>
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #D0D0D0",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {row?.first_name ? row?.first_name : "--"}
                        <span> </span>
                        {row?.last_name ? row?.last_name : "--"}
                      </TableCell>
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #D0D0D0",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        <select
                          onChange={(event) =>
                            handleStatusChange(event, row?.mobile_no)
                          }
                        >
                          <option value={"PENDING"}>PENDING</option>
                          <option value={"FAIL"}>FAIL</option>
                          <option value={"SUCCESS"}>SUCCESS</option>
                        </select>
                      </TableCell>
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {row?.payment_link_sent ? (
                          <FileDownloadDoneIcon className="!bg-green-500 !text-white rounded-full" />
                        ) : (
                          <Button
                            className="!bg-sky-500"
                            size="small"
                            onClick={() => openPaymentLink(row)}
                          >
                            Send{" "}
                          </Button>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="child-modal-title"
          aria-describedby="child-modal-description"
        >
          <Box sx={{ ...style, width: 430 }} className="rounded-2xl !border-0">
            <div
              id="child-modal-title "
              className="!text-black !underline !font-bold !py-3 !text-center !text-xl"
            >
              Send Payment Link
            </div>
            <TextField
              size="small"
              id="outlined-basic"
              label="Vendor Name"
              variant="outlined"
              className="!w-[100%] !mt-2"
              // defaultValue={rowData?.first_name ? rowData?.first_name : ""}
              value={"" || rowData?.first_name}
              onChange={(event) => setVendorName(event.target.value)}
            />
            <br />
            <TextField
              id="outlined-basic"
              label="Vendor Email"
              size="small"
              variant="outlined"
              className="!w-[100%] !mt-3"
              // defaultValue={rowData?.email ? rowData?.email : ""}
              value={"" || rowData?.email}
              onChange={(event) => setVendorEmail(event.target.value)}
            />
            <br />
            <TextField
              id="outlined-basic"
              size="small"
              label="Vendor Mobile"
              variant="outlined"
              className="!w-[100%] !mt-3"
              // defaultValue={rowData?.mobile_no ? rowData?.mobile_no : ""}
              value={"" || rowData?.mobile_no}
              onChange={(event) => setVendorMobile(event.target.value)}
            />
            <br />
            <TextField
              id="outlined-basic"
              size="small"
              label="Vendor Store"
              variant="outlined"
              className="!w-[100%] !mt-3"
              // defaultValue={rowData?.store_name ? rowData?.store_name : ""}
              value={"" || rowData?.store_name}
              onChange={(event) => setVendorStore(event.target.value)}
            />
            <br />
            <Button
              onClick={handleClose}
              variant="contained"
              color="warning"
              className="!py-2 !mt-3"
            >
              CANCEL
            </Button>
            <Button
              variant="contained"
              color="success"
              className="!py-2 !px-5 !font-bold !mt-3 !float-right"
              onClick={sendPaymentData}
            >
              SEND
            </Button>
          </Box>
        </Modal>
      </div>
    </>
  );
};

export default WalletManagement;
